import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Empty, Input, Modal, Row, Table } from "antd";
import {useContext, useState} from "react";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { Entidad } from "../../../../models/Maestras/maestras.model";
import { openNotification } from "../../../../utils/Notifactions";
import {TemplateContext} from "../../../../utils/template_context";

interface IModalEntidad {
    openModal: boolean,
    setOpenModal: Function,
    isEdit: boolean,
    entidades: Entidad[]
    obtenerEntidad: Function
    datos: Entidad
    setDatos: Function
}


export const ModalEntidad = ({ openModal, setOpenModal, entidades, isEdit, obtenerEntidad, datos, setDatos }: IModalEntidad) => {
    const context = useContext(TemplateContext);
    const onCancel = () => {
        setOpenModal(false)
    }

    const [entidad, setEntidad] = useState<Entidad>({
        nombre: ''
    })

    const [datosEntidad, setDatosEntidad] = useState<Entidad>({
        id: 0,
        nombre: '',
        fecha_actualizacion: '',
        fecha_creacion: ''
    })

    const [modalVisible, setModalVisible] = useState(false);
    const editEntidad = (datos: Entidad) => {
        setDatosEntidad(datos);
        setModalVisible(true);
    }


    const addEntidad = async () => {
        if (entidad.nombre !== '') {
            try {
                const data = await apiMaestras.crearEntidad(entidad);
                if(!data.ok){
                    return openNotification({
                        titulo: "Error",
                        descripcion: data.message,
                        placement: "bottomRight",
                      })
                }
                obtenerEntidad();
                setEntidad({
                    nombre: ''
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    const actualizarEntidad = async () => {
        try {
            const resp = await apiMaestras.actualizarEntidad(datosEntidad);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerEntidad();
            setModalVisible(false)
        } catch (error) {
            console.log(error);
        }
    }

    const guardarTodo = () => {
        obtenerEntidad();
        setOpenModal(false);
        setEntidad({
            nombre: '',
        })
    }

    const guardarEdicion = async () => {
        try {
            const resp = await apiMaestras.actualizarEntidad(datos);
            if(!resp){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerEntidad();
            setOpenModal(false)
        } catch (error) {
            console.log(error);
        }
    }

    const deleteEntidad = async (datos: Entidad) => {
        try {
            const resp = await apiMaestras.eliminarEntidad(datos.id);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerEntidad();
        } catch (error) {
            console.log(error);
        }
    }


    const columns: any = [
        {
            title: "Nombre entidad",
            key: "nombre",
            dataIndex: "nombre",
            //  fixed: context.device === "md"? "left": false,
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                    <div className="controls">
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Editar
                        </div>
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Eliminar
                        </div>
                    </div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg"? "right": false,
            render: (datos: Entidad) => (
                <div className="controls">
                    <EditOutlined onClick={() => editEntidad(datos)} />
                    <DeleteOutlined onClick={() => deleteEntidad(datos)} />
                </div>
            )
        },
    ]


    return (
        <>
            <Modal
                title={
                    <>
                        {isEdit
                            ?
                            (
                                <div>Editar Entidad</div>
                            )
                            :
                            (

                                <div>Crear Entidad</div>
                            )
                        }
                    </>
                }
                visible={openModal}
                onCancel={onCancel}
                width={1000}
                footer={
                    <>
                        {isEdit
                            ?
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarEdicion}>Guardar y Finalizar</Button>
                                    </Col>
                                </Row>
                            )
                            :
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarTodo}>Cerrar</Button>
                                    </Col>
                                </Row>
                            )
                        }
                    </>
                }
            >
                {isEdit ?
                    (
                        <Row>
                            <Col span={24}>
                                <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                    Nombre Entidad
                                </span>
                                <Input value={datos.nombre} onChange={(e) => setDatos({ ...datos, nombre: e.target.value })} />
                            </Col>
                        </Row>
                    )
                    :
                    (
                        <>
                            <Row>
                                <Col span={24}>
                                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                        Nombre Entidad
                                    </span>
                                    <Input value={entidad.nombre} onChange={(e) => setEntidad({ ...entidad, nombre: e.target.value })} />
                                </Col>
                            </Row>
                            <Row justify="end">
                                <Col>
                                    <Button className="button-azul-radius" onClick={addEntidad}>Guardar</Button>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div>Entidades creadas</div>
                                </Col>
                                <Col>
                                    <Table
                                        dataSource={entidades}
                                        columns={columns}
                                        locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                        style={{ borderTop: "1px solid #C4C4C4" }}
                                        size="small"
                                        bordered={false}
                                        pagination={false}
                                        scroll={{ x: 1500, y: 300 }}
                                    />
                                </Col>
                            </Row>
                        </>
                    )
                }
            </Modal>
            {modalVisible &&
                <Modal
                    title="Editar entidad"
                    visible={modalVisible}
                    onCancel={() => setModalVisible(false)}
                    width={1000}
                    footer={
                        <Row justify="end" gutter={[24, 24]}>
                            <Col>
                                <Button className="button-blanco-radius" onClick={() => setModalVisible(false)}>Cancelar</Button>
                            </Col>
                            <Col>
                                <Button className="button-azul-radius" onClick={actualizarEntidad}>Guardar Cambios</Button>
                            </Col>
                        </Row>
                    }
                >
                    <Row>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre entidad
                            </span>
                            <Input value={datosEntidad.nombre} onChange={(e) => setDatosEntidad({ ...datosEntidad, nombre: e.target.value })} />
                        </Col>
                    </Row>

                </Modal>
            }
        </>
    )
}
